import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { applyTheme } from "@/context/ThemeProvider";
import { setFavicon } from "@/lib/favicon";

const OperatorContext = createContext(null);

export function OperatorProvider({ children }) {
  const [ctx, setCtx] = useState(null);

  const reload = useCallback(async () => {
    const { data } = await api.get("/operator/context");
    setCtx(data);
    applyTheme(data.branding?.tokens);
    setFavicon({
      logoUrl: data.branding?.logo_file ? `/api/public/branding/${data.tenant?.id}/logo` : null,
      name: data.branding?.logo_text || data.tenant?.name,
      primary: data.branding?.tokens?.["--tenant-primary"],
    });
    return data;
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const featureEnabled = (key) =>
    !!ctx?.features?.find((f) => f.feature_key === key && f.enabled);

  return (
    <OperatorContext.Provider value={{ ctx, reload, featureEnabled }}>
      {children}
    </OperatorContext.Provider>
  );
}

export const useOperator = () => useContext(OperatorContext);
